import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { convertDateFormat, sanitize } from '../../utils';
import useDataStore from '../Data/dataStore';
import { getAllNews, isMobileWidth } from '../globalUtils';
import Div from '../Page/Div';
import FixedContainer from '../Page/FixedContainer';
import usePageStore from '../Page/pageStore';
import AccordionButtonGraphics from '../UI/AccordionButtonGraphics';
import { WPImage } from '../UI/WPImage';
const HomeNewsSection = ({ content, idx, allowOpen, }) => {
    const { shownPage } = usePageStore();
    const { title, button, full_page } = content?.home_page_news ?? {};
    const [showImageIdx, setShowImageIdx] = useState(full_page ? -1 : 0);
    const [hovers, setHovers] = useState({});
    const [zIndexes, setZIndexes] = useState({});
    const [showTracker, setShowTracker] = useState(false);
    const followerRef = useRef(null);
    const mousePos = useRef({
        x: window.innerWidth / 2,
        y: window.innerHeight / 2,
    });
    const scale = useRef(0);
    const data = useDataStore((state) => state.data);
    const snappy = !!content.force_snap;
    const mixedNews = getAllNews(data);
    let displayedNews = mixedNews.sort((a, b) => a.date > b.date ? -1 : 1);
    if (!full_page) {
        displayedNews = displayedNews
            .filter((item) => !item.link?.includes(shownPage))
            .slice(0, 3);
    }
    const hoverCounter = useRef(0);
    const onHover = (idx, state) => {
        if (state) {
            hoverCounter.current = hoverCounter.current + 1;
            setZIndexes((z) => ({ ...z, [idx]: hoverCounter.current }));
            setShowImageIdx(idx);
        }
        setHovers((h) => {
            return { ...h, [idx]: state };
        });
    };
    const newsImages = displayedNews.map((item, idx) => {
        const { image } = item;
        return (_jsx("div", { className: `news-main-image${showImageIdx === idx ? ' show' : ''}`, style: { zIndex: zIndexes[idx] ?? 0 }, children: _jsx(WPImage, { id: image, className: "news-main-image-wrapper" }, `${image}-${idx}`) }));
    });
    return (_jsx(FixedContainer, { blocked: !snappy, idx: idx, allowOpen: allowOpen, parentClassName: `home-news-container${!snappy && !full_page ? ' compact' : ''}${!snappy ? ' scrollable' : ''}`, sliderClassName: `home-news-wrapper`, noIntroDelay: true, children: !displayedNews || !displayedNews.length
            ? []
            : [
                !full_page ? (_jsx(Div, { blocked: !allowOpen, className: "home-news-image", delay: 1, noScale: true, style: {
                        height: `calc(${Math.min(displayedNews.length, 4)} * var(--accordionButtonHeight) + var(--titleHeight))`,
                    }, children: newsImages }, "0")) : null,
                _jsx(Div, { blocked: !allowOpen, className: "home-news-title", delay: 0, noScale: true, children: _jsx("div", { className: "home-news-title-wrapper", children: _jsx("div", { dangerouslySetInnerHTML: {
                                __html: sanitize(title),
                            } }) }) }, "1"),
                ...displayedNews.map((item, idx) => {
                    const { name, link, date, image } = item;
                    const internalLink = !!link?.startsWith('/');
                    const button = (_jsxs(AccordionButtonGraphics, { details: name, idx: idx, onHover: onHover, children: [_jsx("span", { className: "home-news-date", children: convertDateFormat(date) }), !!full_page && (_jsx("div", { className: `home-news-image-slider${full_page && !isMobileWidth() && hovers[idx] ? ' show' : ''}`, children: _jsx("div", { className: "home-news-image-slider-wrapper", children: _jsx(WPImage, { id: image }, image) }) }))] }, name));
                    return (_jsx(Div, { blocked: !allowOpen, className: `home-news-button${!idx ? ' first-button' : ''}`, delay: idx, noScale: true, children: internalLink ? (_jsx(Link, { to: link, "aria-label": name, children: button })) : (_jsx("a", { href: link, target: "_blank", "aria-label": name, children: button })) }, name));
                }),
                button?.url ? (_jsx(Div, { blocked: !allowOpen, className: "home-news-more", delay: 6, noScale: true, children: _jsx("div", { className: "home-news-more-wrapper", children: _jsx(Link, { to: button.url, "aria-label": "Visit News", children: _jsx("div", { className: "button", children: button.title }) }) }) }, "4")) : null,
            ] }));
};
export default HomeNewsSection;
